/* eslint-disable react/require-default-props */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { rawAssetDetailsInitialState } from '../../state/rawAssetDetails.ts';
import {
  addAssetDetails,
  addEditableAssetDetails,
  resetAssetDetails,
  resetEditableAssetDetails,
} from '../../state/previewAsset';
import { disableEditMetadata } from '../../state/editMetadata';
import { openWarningDialog } from './state/warningDialog';
import {
  generateRenderableAssetDetails,
  generateEditableAssetDetails,
} from '../../utils/assetDetails/generateRenderableAssetDetails';
import { AssetDetails } from '../Shared/AssetDetails';

class AssetInfo extends Component {
  componentDidUpdate(prevProps) {
    const {
      rawAssetDetails, disableEditMetadata, isQuerying,
    } = this.props;
    const isAssetSelected = rawAssetDetails?._id !== undefined;
    const newSearchTriggered = isQuerying && !prevProps.isQuerying;
    const assetChanged = JSON.stringify(rawAssetDetails) !== JSON.stringify(prevProps.rawAssetDetails);
    // VV-315: the profile list can arrive after the asset; built before it, the Security field
    // would name nothing. Rebuilt when it lands, outside edit mode so no edit in progress is lost.
    const profilesArrived = this.props.securityProfileIdValueMapping !== prevProps.securityProfileIdValueMapping
      && !this.props.isAssetEditable;

    if (isAssetSelected && (assetChanged || profilesArrived)) {
      const {
        metaTagsByCategory,
        addAssetDetails,
        addEditableAssetDetails,
        securityProfileIdValueMapping,
      } = this.props;
      const assetDetails = generateRenderableAssetDetails(
        metaTagsByCategory,
        rawAssetDetails,
        securityProfileIdValueMapping,
      );
      const editableAssetDetails = generateEditableAssetDetails(
        metaTagsByCategory,
        rawAssetDetails,
        securityProfileIdValueMapping,
      );

      addAssetDetails(assetDetails);
      addEditableAssetDetails(editableAssetDetails);
      if (assetChanged) disableEditMetadata();
    }

    if (newSearchTriggered) {
      const {
        resetAssetDetails,
        resetEditableAssetDetails,
        isAssetEditable,
        openWarningDialog,
        rawAssetDetailsInitialState,
      } = this.props;

      if (isAssetEditable) openWarningDialog();

      resetAssetDetails();
      resetEditableAssetDetails();
      rawAssetDetailsInitialState();
    }
  }

  handleUseAsUpdate = () => {
    const {
      resetAssetDetails,
      resetEditableAssetDetails,
      isAssetEditable,
      openWarningDialog,
      rawAssetDetailsInitialState,
    } = this.props;

    if (isAssetEditable) openWarningDialog();

    resetAssetDetails();
    resetEditableAssetDetails();
    rawAssetDetailsInitialState();
  };

  render() {
    const {
      previewAsset: { isLoaded, assetDetails, editableAssetDetails },
      rawAssetDetails,
      isAssetEditable,
    } = this.props;

    return (
      <AssetDetails
        isLoaded={isLoaded}
        assetDetails={isAssetEditable ? editableAssetDetails : assetDetails}
        rawAssetDetails={rawAssetDetails}
        isAssetEditable={isAssetEditable}
        onUseAsUpdate={this.handleUseAsUpdate}
      />
    );
  }
}

AssetInfo.propTypes = {
  rawAssetDetails: PropTypes.object.isRequired, // supplied from Redux
  isAssetEditable: PropTypes.bool.isRequired, // supplied from Redux
  metaTagsByCategory: PropTypes.array.isRequired, // supplied from Redux
  securityProfileIdValueMapping: PropTypes.array.isRequired, // supplied from Redux
  addAssetDetails: PropTypes.func.isRequired, // supplied from Redux
  addEditableAssetDetails: PropTypes.func.isRequired, // supplied from Redux
  resetAssetDetails: PropTypes.func.isRequired, // supplied from Redux
  resetEditableAssetDetails: PropTypes.func.isRequired, // supplied from Redux
  previewAsset: PropTypes.object.isRequired, // supplied from Redux
  disableEditMetadata: PropTypes.func.isRequired, // supplied from Redux
  isQuerying: PropTypes.bool.isRequired, // supplied from Redux
  openWarningDialog: PropTypes.func.isRequired, // supplied from Redux
  rawAssetDetailsInitialState: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  rawAssetDetails: state.rawAssetDetails,
  isAssetEditable: state.editMetadata?.isEditable ?? false,
  securityProfileIdValueMapping: state.securityProfiles?.idValueMapping ?? [],
  metaTagsByCategory: state.metatags?.metaTags ?? [],
  previewAsset: state.previewAsset,
  isQuerying: state.search?.isQuerying ?? false,
});

const mapDispatchToProps = {
  addAssetDetails,
  addEditableAssetDetails,
  resetAssetDetails,
  resetEditableAssetDetails,
  disableEditMetadata,
  openWarningDialog,
  rawAssetDetailsInitialState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetInfo);
